export default "__VITE_ASSET__jHRsG0Sm__"